/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import DashboardPage from "../../../layout";
import { getGlobalFilter } from "../../../api/filters";
import PaginationComponent from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import Export from "../../../assets/icons/Export.svg";
import Filter from "../../../assets/icons/Filter.svg";
import { toast, ToastContainer } from "react-toastify";
import DropdownMulti from "../../../components/DropdownMultiple";
import Dropdown from "../../../components/Dropdown";
import {
  formatCurrentStartDate,
  formatCurrentEndDate,
  getPagePerSize,
  formatDate,
  formatTime,
} from "../../../utility";
import TimeFrameSelector from "../../../components/TimeFrameSelector";
import { useTranslation } from "react-i18next";
import Close from "../../../assets/close-circle.svg";
import Search from "../../../assets/Search.svg";
import { useNavigate } from "react-router-dom";
import { TimeZoneDisplay } from "../../../utility";
import Button from "../../../components/Button";
import { getDeliveryImagesReport , getDeliveryProofPresignedUrl} from "../../../api/delivery-driver";
import debounce from "lodash/debounce";
import Eye from "../../../assets/eye.svg";
import { delivery_man } from "../../../utility/constant";
import ImageDailog from "../../../components/ImageDailog";
import moment from "moment";
const DeliveryImagesReport: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [employees, setEmployeesData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingForFilter] = useState(false);
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [deliveryTimeFrame, setDeliveryTimeFrame] = useState<any>("Today");
  const [deliveryStartDate, setDeliveryStartDate] = useState<any>(new Date());
  const [deliveryEndDate, setDeliveryEndDate] = useState<any>(new Date());
  const [filterByCreatedAt, setFilterByCreatedAt] = useState<boolean>(true);
  const [filterByDeliveredAt, setFilterByDeliveredAt] = useState<boolean>(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState<any>();
  const [imgType, setImgType] = useState<any>();
  const [viewImg, setViewImg] = useState<any>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortType, setSortType] = useState<any>("");
  const { t } = useTranslation();
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState<any>([]);
  const [selectedEmpStatus, setSelectedEmpStauts] = useState<any>("");
  const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>([]);
  const [selectedRegion, setRegion] = useState<any>([]);
  const [territoryId, setTerritoryId] = useState<any>([]);
  const [routeId, setRouteId] = useState<any>([]);
  const [userType, setUserType] = useState<any>("");
  const [channelId, setChannelId] = useState<any>([]);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const [selectReason, setSelectReason] = useState<string | null>(null);
  const [selectDriverId, setSelectDriverId] = useState<string | null>(null);
  const startIndex = (currentPage - 1) * employees?.size;
  const navigate = useNavigate();
  const employeesPerPage = getPagePerSize();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // Add: Track the selected order index for update
  const [selectedOrderIndex, setSelectedOrderIndex] = useState<number | null>(null);

  // Callback to update order status in local state
  const handleOrderStatusUpdate = (orderId: string, updateObj: any) => {
    setEmployeesData((prev: any) => {
      if (!prev?.items) return prev;
      const updatedItems = prev.items.map((item: any) =>
        item.order_id === orderId ? { ...item, ...updateObj } : item
      );
      return { ...prev, items: updatedItems };
    });
  };

  const getGlobalFilters = async (data: any) => {
    try {
      setLoadingForFilter(true);
      const response = await getGlobalFilter(data);
      setLoadingForFilter(false);
      setGlobalFilters(response);
    } catch (error) {
      console.error("Error fetching global filters:", error);
    }
  };

  const handleFilterClick = () => {
    setOpen(true);
  };

  const handleChange = (event: any) => {
    setSearchQuery(event);
    updateSearchTerm(event);
  };

  const handleOpenPopup = (data: any, idx?: number) => {
    setSelectedOrderId(data);
    setSelectReason(data.reason_for_rejection)
    setSelectDriverId(data.driver_id)
    setIsPopupOpen(true);
    // Track the index for possible use (optional)
    if (typeof idx === 'number') setSelectedOrderIndex(idx);
  };
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  const handleSortFillter = (data: string) => {
    if (data === sortType) {
      setSortType("");
      handleApply("");
    } else {
      setSortType(data);
      handleApply(data);
    }

    setIsDropdownOpen(false);
  };

  function getCurrentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClose = () => setOpen(false);

  const handleClearFilters = () => {
    setSelectedEmpId([]);
    setSelectedSalesOffice([]);
    setRegion([]);
    setTerritoryId([]);
    setRouteId([]);
    setUserType(null);
    setChannelId([]);
    setSelectedEmpStauts(null);
    setStartDate(getCurrentDate());
    setEndDate(getCurrentDate());
    setSelectTimeFrame("Today");
    setDeliveryStartDate(getCurrentDate());
    setDeliveryEndDate(getCurrentDate());
    setDeliveryTimeFrame("Today");
    setFilterByCreatedAt(true);
    setFilterByDeliveredAt(false);
    setOpen(false);
    handleClearApply("");
  };

  const handleClearApply = (sort: string) => {
    const data: any = {
      start_date: formatCurrentStartDate(new Date()),
      end_date: formatCurrentEndDate(new Date()),
    };
    data["positions"] = [delivery_man];
    const params = {
      page: 1,
      size: employeesPerPage,
    };
    setCurrentPage(1);
    getRejectionData(data, params);
    handleClose();
  };

  const getPayload = (data: any) => {
    if (selectedEmpStatus) {
      data["status"] = selectedEmpStatus;
    }

    if (channelId.length > 0) {
      data["channel_ids"] = channelId;
    }
    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (userType) {
      data["user_type"] = userType;
    }
    
    // Add filter flags - both can be true now
    data["filter_by_created_at"] = filterByCreatedAt;
    data["filter_by_delivered_at"] = filterByDeliveredAt;
    
    // Add date fields based on which filter is active
    if (filterByCreatedAt && !filterByDeliveredAt) {
      // Only created date filter is active
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    } else if (filterByDeliveredAt && !filterByCreatedAt) {
      // Only delivery date filter is active
      data["start_date"] = formatCurrentStartDate(new Date(deliveryStartDate));
      data["end_date"] = formatCurrentEndDate(new Date(deliveryEndDate));
    } else if (filterByCreatedAt && filterByDeliveredAt) {
      // Both filters are active - use created date as primary
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
      // Add delivery dates as additional fields if needed by backend
      data["delivery_start_date"] = formatCurrentStartDate(new Date(deliveryStartDate));
      data["delivery_end_date"] = formatCurrentEndDate(new Date(deliveryEndDate));
    }
    
    data["positions"] = [delivery_man];
  };

  const handleExport = async () => {
    setLoading(true);
    const data: any = {
      export: true,
      time_zone: TimeZoneDisplay(),
    };

    if (searchQuery) {
      data["search"] = searchQuery;
    }
    if (sortType) {
      data["sort_by"] = sortType;
    }
    getPayload(data);

    const params = {};
    try {
      await exportActiviyData(data, params);
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportActiviyData = async (data: any, params: any) => {
    await getDeliveryImagesReport(params, data)
    .then((res) => {
      toast.success(res?.data?.message)
      // const url = window.URL.createObjectURL(new Blob([res]));
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `team_activity_report.csv`;
      // a.click();
      // a.remove();
      // window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Error fetching Employee data:", error);
      toast.warn(error?.response?.data?.detail)
    });
  };

  const getRejectionData = async (data: any, params: any) => {
    setLoading(true);
    await getDeliveryImagesReport(params, data)
      .then((res) => {
        setEmployeesData(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching Employee data:", error);
        setLoading(false);
      });
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStartDate(e.target.value);
    checkTimeFrame(e.target.value, endDate);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
    checkTimeFrame(startDate, e.target.value);
  };

  const handleDeliveryStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDeliveryStartDate(e.target.value);
    checkDeliveryTimeFrame(e.target.value, deliveryEndDate);
  };

  const handleDeliveryEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDeliveryEndDate(e.target.value);
    checkDeliveryTimeFrame(deliveryStartDate, e.target.value);
  };

  useEffect(() => {
    const data: any = {};

    if (searchQuery) {
      data["search"] = searchQuery;
    }

    getPayload(data);

    const params = {
      page: currentPage,
      size: employeesPerPage,
    };
    getRejectionData(data, params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    const data: any = {};

    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
    getGlobalFilters(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFiltersUpdate = () => {
    const data: any = {};

    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
    getGlobalFilters(data);
  };

  const updateSearchTerm = useCallback(
    debounce((value: string) => {
      const data: any = {};

      if (value) {
        data["search"] = value;
      }
      getPayload(data);
      const params = {
        page: 1,
        size: employeesPerPage,
      };
      setCurrentPage(1);
      getRejectionData(data, params);
    }, 500),
    [
      startDate,
      endDate,
      deliveryStartDate,
      deliveryEndDate,
      filterByCreatedAt,
      filterByDeliveredAt,
      selectedEmpStatus,
      channelId,
      selectedRegion,
      routeId,
      selectedSalesOffice,
      selectedEmpId,
      territoryId,
      userType,
      sortType,
      employeesPerPage,
    ]
  );
  const handleSetImage = async (url: any, type: string) => {
    try {
        setImageLoading(true);
        const presignedUrl = await getDeliveryProofPresignedUrl(url);
        setImgUrl(presignedUrl);
        setViewImg(true);
        setImgType(type);
    } catch (error) {
        setImgUrl(null);
        setViewImg(false);
    } finally {
        setImageLoading(false);
    }
};
  const handleApply = (sort: string) => {
    setCurrentPage(1);
    const data: any = {};
    if (searchQuery) {
      data["search"] = searchQuery;
    }
    getPayload(data);
    if (sort) {
      data["sort_by"] = sort;
    }
    const params = {
      page: 1,
      size: employeesPerPage,
    };

    getRejectionData(data, params);
    handleClose();
  };

  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setSelectTimeFrame("Month till date");
    } else {
      setSelectTimeFrame("");
    }
  };

  const checkDeliveryTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setDeliveryTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setDeliveryTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setDeliveryTimeFrame("Month till date");
    } else {
      setDeliveryTimeFrame("");
    }
  };

  useEffect(() => {
    setSelectedSalesOffice("");
    setTerritoryId("");
    setRouteId("");
    setSelectedEmpId("");
  }, [selectedRegion]);

  useEffect(() => {
    setTerritoryId("");
    setRouteId("");
    setSelectedEmpId("");
  }, [selectedSalesOffice]);

  useEffect(() => {
    setRouteId("");
    setChannelId("");
    setSelectedEmpId("");
  }, [territoryId]);

  useEffect(() => {
    if (selectedEmpId) {
      globalFilters?.employees?.map((value: any) => {
        if (selectedEmpId === value.id) {
          setUserType(value.position);
        }
      });
    } else {
      setUserType("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmpId]);

  return (
    <DashboardPage>
      <div className="bg-gray-50  sm:pl-0 pr-4 ">
        {/* Report Title */}
        <div className="bg-white p-4 border-b-2">
          <h1 className="text-l font-bold text-gray-800">
            {t("deliveryimagesreport.title")}
          </h1>
        </div>
        <div className="hidden mb-2 sm:flex flex-col sm:flex-row justify-between items-center bg-white p-2 border-b-2">
          <div className="w-full sm:w-auto mb-4 sm:mb-0 pl-6">
            <PaginationComponent
              totalCount={employees?.total}
              itemsPerPage={employees?.size}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4">
            <div className="relative w-full sm:w-auto">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                {/* Add your search icon here */}
                <img src={Search} alt="search" />
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={t("planogram.searchPlaceholder")}
                className="w-full sm:w-auto pl-10 pr-4 py-2 text-16 border rounded text-gray-600"
                style={{ borderColor: "#e0e0e0" }}
              />
            </div>

            {/* Buttons group for desktop */}
            <div className="hidden sm:flex space-x-4 items-center">
              {/* <button
                onClick={handleSort}
                className="flex items-center px-4 py-2 text-16 text-gray-600 rounded transition-all"
              >
                <img src={Sort} alt="Sort Icon" className="w-4 h-4 mr-2" />
                Sort by
              </button> */}
              {isDropdownOpen && (
                <ul className="absolute z-50 right-30 top-10 w-48 bg-white border border-gray-300 rounded shadow-lg">
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${sortType === "ASC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("ASC")}
                  >
                    {t("planogram.ascending")}
                  </li>
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer  ${sortType === "DESC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("DESC")}
                  >
                    {t("planogram.descending")}
                  </li>
                </ul>
              )}
                            <button
                onClick={handleExport}
                className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                    {t("masterList.exporting")}
                  </span>
                ) : (
                  <>
                    {t("masterList.export")}
                    <img
                      src={Export}
                      alt={t("masterList.export")}
                      className="w-4 h-4 "
                    />
                  </>
                )}
              </button>
              <button
                onClick={handleFilterClick}
                className="flex items-center gap-2 px-4 py-2 text-13 font-normal rounded transition-all"
              >
                <img
                  src={Filter}
                  alt={t("planogram.filter")}
                  className="w-4 h-4 mr-2"
                />
                {t("planogram.filter")}
              </button>


            </div>
          </div>
        </div>
        <div className="sm:hidden flex justify-between items-center p-2 border-b-2 bg-white">
          <div className="flex-grow">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => handleChange(e.target.value)}
              placeholder={t("planogram.searchPlaceholder")}
              className="w-full px-4 py-2 text-13 border rounded text-gray-600"
              style={{ borderColor: "#e0e0e0" }}
            />
          </div>

          {/* Hamburger menu for Sort, Filter, Export */}
          <div className="flex items-center space-x-2">
            <button
              onClick={handleExport}
              className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                  {t("masterList.exporting")}
                </span>
              ) : (
                <>
                  {t("masterList.export")}
                  <img
                    src={Export}
                    alt={t("masterList.export")}
                    className="w-4 h-4 "
                  />
                </>
              )}
            </button>

            <button
              className="px-2 py-2 text-gray-600 rounded transition-all"
              onClick={() => setOpen(!open)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        {open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
            <div className="relative bg-white shadow-lg w-full max-w-md h-full">
              <div className="absolute z-30 top-[50%] left-[45%]">
                {loadingFilter && <Loader />}
              </div>
              <div className="flex justify-between p-6 border-b-2">
                <div className="text-16 font-bold">
                  {t("visitreports.filters.title")}
                </div>
                <div>
                  <img
                    className="cursor-pointer"
                    onClick={() => setOpen(false)}
                    src={Close}
                    alt=""
                  />
                </div>
              </div>
              <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6 overflow-y-auto scrollbar scrollbar-thin">
                <div className="flex flex-col gap-[30px]">
                   <div className="flex space-x-4">
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.region")}
                        options={globalFilters?.regions.map((sales: any) => ({
                          value: sales,
                          label: sales,
                        }))}
                        selectedValues={selectedRegion}
                        showSelectAll={true}

                        onClose={handleFiltersUpdate}
                        onChange={setRegion}
                        placeholder={t("visitreports.filters.selectRegion")}
                      />
                    </div>
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.salesOffice")}
                        options={
                          globalFilters?.sales_offices.map((sales: any) => ({
                            value: sales.id,
                            label: sales.name,
                          })) || []
                        }
                        selectedValues={selectedSalesOffice}
                        onClose={handleFiltersUpdate}
                        showSelectAll={true}

                        onChange={setSelectedSalesOffice}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectSalesOffice"
                        )}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4">
                    {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.territoryID")}
                        options={
                          globalFilters?.territories?.map((emp: any) => ({
                            value: String(emp.territory_id),
                            label: emp.territory_identifier,
                          })) || []
                        }
                        selectedValues={territoryId}
                        onChange={setTerritoryId}
                        onClose={handleFiltersUpdate}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectTerritoryID"
                        )}
                      />
                    </div> */}

                    <div className="w-full">
                      <DropdownMulti
                        label={t("visitreports.filters.channelID")}
                        options={
                          globalFilters?.channels?.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name,
                          })) || []
                        }
                        selectedValues={channelId}
                        onClose={handleFiltersUpdate}
                        onChange={setChannelId}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectChannelID")}
                      />
                    </div>
                  </div>
                  {/* <div> */}
                    {/* <div className="w-full">
                      <DropdownMulti
                        label={t("visitreports.filters.routeID")}
                        options={
                          globalFilters?.routes?.map((emp: any) => ({
                            value: `${emp.route_id}`,
                            label: emp.route_identifier,
                          })) || []
                        }
                        selectedValues={routeId}
                        onClose={handleFiltersUpdate}
                        onChange={setRouteId}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectRouteID")}
                      />
                    </div> */}
                  {/* </div> */}
                  {/* <div className="flex gap-4"> */}
                    {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("ActivityReport.employeeName")}
                        options={
                          globalFilters?.employees.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng,
                          })) || []
                        }
                        selectedValues={selectedEmpId}
                        onClose={handleFiltersUpdate}
                        onChange={setSelectedEmpId}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("ActivityReport.employeeName")}
                        searchable={true}
                      />
                    </div> */}
                    {/* <div className="w-1/2">
                      <Dropdown
                        label={t("visitreports.filters.userType")}
                        options={
                          globalFilters?.user_types.map((emp: any) => ({
                            value: emp,
                            label: emp,
                          })) || []
                        }
                        selectedValue={userType}
                        onChange={setUserType}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectUserType")}
                      />
                    </div> */}
                  {/* </div>  */}

                  <div 
                    className={`date-range-picker space-y-2 p-4 border-2 rounded-lg cursor-pointer ${
                      filterByCreatedAt 
                        ? 'border-purple-500 bg-purple-50' 
                        : 'border-gray-200 bg-gray-50 opacity-60 hover:opacity-80 hover:border-gray-300'
                    }`}
                    onClick={() => {
                      setFilterByCreatedAt(true);
                      setFilterByDeliveredAt(false);
                    }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <label className={`block text-14 font-semibold ${
                        filterByCreatedAt ? 'text-gray-700' : 'text-gray-500'
                      }`}>
                       Filter By Order Creation Date:
                      </label>
                    </div>
                    <div className="flex space-x-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.startDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByCreatedAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                          }`}
                          value={startDate}
                          onChange={handleStartDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(true);
                            setFilterByDeliveredAt(false);
                          }}
                          max={new Date(endDate).toISOString().split("T")[0]}
                          min={(() => {
                            const end = new Date(endDate);
                            const minDate = new Date(end);
                            minDate.setDate(end.getDate() - 30);
                            return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                          })()}
                          // disabled={
                            
                          //   !selectedRegion || (Array.isArray(selectedRegion) ? selectedRegion.length === 0 : !selectedRegion) ||
                          //   !selectedSalesOffice || (Array.isArray(selectedSalesOffice) ? selectedSalesOffice.length === 0 : !selectedSalesOffice)
                          // }
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.endDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByCreatedAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                          }`}
                          max={new Date().toISOString().split("T")[0]}
                          min={new Date(startDate).toISOString().split("T")[0]}
                          value={endDate}
                          onChange={handleEndDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(true);
                            setFilterByDeliveredAt(false);
                          }}
                          // disabled={
                        
                          //   !selectedRegion || (Array.isArray(selectedRegion) ? selectedRegion.length === 0 : !selectedRegion) ||
                          //   !selectedSalesOffice || (Array.isArray(selectedSalesOffice) ? selectedSalesOffice.length === 0 : !selectedSalesOffice)
                          // }
                        />
                      </div>
                    </div>
                    <div>
                                          <div                           onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(true);
                            setFilterByDeliveredAt(false);
                          }}>
                        <TimeFrameSelector
                          customClass={`w-full border-2 rounded p-2 ${
                            filterByCreatedAt ? 'border-gray-300' : 'border-gray-300 bg-gray-100'
                          }`}
                          setSelectTimeFrame={setSelectTimeFrame}
                          timeFrame={timeFrame}
                          setStartDate={setStartDate}
                          setEndDate={setEndDate}
                          // disabled={
                    
                          //   !selectedRegion || (Array.isArray(selectedRegion) ? selectedRegion.length === 0 : !selectedRegion) ||
                          //   !selectedSalesOffice || (Array.isArray(selectedSalesOffice) ? selectedSalesOffice.length === 0 : !selectedSalesOffice)
                          // }
                        />
                      </div>
                  </div>
                  </div>

  

                  {/* Delivery Date Section */}
                  <div 
                    className={`date-range-picker space-y-2 p-4 border-2 rounded-lg cursor-pointer ${
                      filterByDeliveredAt 
                        ? 'border-purple-500 bg-purple-50' 
                        : 'border-gray-200 bg-gray-50 opacity-60 hover:opacity-80 hover:border-gray-300'
                    }`}
                    onClick={() => {
                      setFilterByCreatedAt(false);
                      setFilterByDeliveredAt(true);
                    }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <label className={`block text-14 font-semibold ${
                        filterByDeliveredAt ? 'text-gray-700' : 'text-gray-500'
                      }`}>
                      Filter By Order Delivery Date:
                      </label>
                    </div>
                    <div className="flex space-x-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.startDate")}:
                        </label>
                        <input
                              
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByDeliveredAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                            
                          }`}
                          value={deliveryStartDate}
                          onChange={handleDeliveryStartDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(false);
                            setFilterByDeliveredAt(true);
                          }}
                          max={new Date(deliveryEndDate).toISOString().split("T")[0]}
                          min={(() => {
                            const end = new Date(deliveryEndDate);
                            const minDate = new Date(end);
                            minDate.setDate(end.getDate() - 30);
                            return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                          })()}
                          // disabled={
              
                          //   !selectedRegion || (Array.isArray(selectedRegion) ? selectedRegion.length === 0 : !selectedRegion) ||
                          //   !selectedSalesOffice || (Array.isArray(selectedSalesOffice) ? selectedSalesOffice.length === 0 : !selectedSalesOffice)
                          // }
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.endDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByDeliveredAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                          }`}
                          max={new Date().toISOString().split("T")[0]}
                          min={new Date(deliveryStartDate).toISOString().split("T")[0]}
                          value={deliveryEndDate}
                          onChange={handleDeliveryEndDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(false);
                            setFilterByDeliveredAt(true);
                          }}
                          // disabled={
              
                          //   !selectedRegion || (Array.isArray(selectedRegion) ? selectedRegion.length === 0 : !selectedRegion) ||
                          //   !selectedSalesOffice || (Array.isArray(selectedSalesOffice) ? selectedSalesOffice.length === 0 : !selectedSalesOffice)
                          // }
                        />
                      </div>
                      
                    </div>
                    <div>
                                          <div                           onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(false);
                            setFilterByDeliveredAt(true);
                          }}>
                        <TimeFrameSelector
                          customClass={`w-full border-2 rounded p-2 ${
                            filterByDeliveredAt ? 'border-gray-300' : 'border-gray-300 bg-gray-100'
                          }`}
                          setSelectTimeFrame={setDeliveryTimeFrame}
                          timeFrame={deliveryTimeFrame}
                          setStartDate={setDeliveryStartDate}
                          setEndDate={setDeliveryEndDate}
                          
                          // disabled={
                           
                          //   !selectedRegion || (Array.isArray(selectedRegion) ? selectedRegion.length === 0 : !selectedRegion) ||
                          //   !selectedSalesOffice || (Array.isArray(selectedSalesOffice) ? selectedSalesOffice.length === 0 : !selectedSalesOffice)
                          // }
                        />
                      </div>
                  </div>
                  </div>

                 
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between mt-4">
                  <Button
                    onClick={handleClearFilters}
                    label={t("visitreports.filters.clearFilter")}
                    type="grey"
                  />
                  <Button
                    onClick={() => handleApply(sortType)}
                    label={t("visitreports.filters.applyFilter")}
                    type="purple"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-125px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
          <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
            <thead className="bg-gray-200 sticky top-[0px] z-20">
              <tr>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-28">
                  {t("deliveryReportTableFields.sap_order_creation_date")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-28">
                  {t("deliveryReportTableFields.sap_order_creation_time")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.sales_office")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.region")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.deliverydate")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.deliverytime")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.Driver_id")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.Driver_Name")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.Delivery_number")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.Channel")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                  {t("deliveryimagesreport.Customer_Id")}
                </th>
               
               
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-36">
                  {t("deliveryReportTableFields.mosque_image_path")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-36">
                  {t("deliveryReportTableFields.cooler_image_path")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-36">
                  {t("deliveryReportTableFields.stock_floor_image_path")}
                </th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-36">
                  {t("deliveryReportTableFields.stamped_invoice_image_path")}
                </th>
              </tr>
            </thead>
            
             <tbody>
              {employees?.items?.length > 0 &&
                !loading &&
                employees.items.map((data: any, index: number) => (
                  <tr
                    key={data.emp_id}
                    className={`text-16  hover:bg-gray-50 ${
                      data.return_delivery_to_driver || data.cancel_order || data.rescheduled ? 'bg-gray-200' : ''
                    }`}
                  >
    

                    {/* Added values based on requested fields */}
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sap_order_creation_date}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sap_order_creation_time?moment
                                                                      .utc(data.sap_order_creation_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sales_office_id}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.region}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_date}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.actual_delivery_time?moment
                                                                      .utc(data.actual_delivery_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.driver_id}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.driver_name}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_number}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.channel_id}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_id}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.mosque_image_path ? (
                          <button onClick={() => handleSetImage(data.mosque_image_path, "Mosque Image")}>
                            <img src={Eye} alt="mosque_image" />
                          </button>
                        ) : "-"}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.cooler_image_path && Number(data.channel_id) !== 40 ? (
                          <button onClick={() => handleSetImage(data.cooler_image_path, "Cooler Image")}>
                            <img src={Eye} alt="cooler_image" />
                          </button>
                        ) : "-"}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.stock_floor_image_path ? (
                          <button onClick={() => handleSetImage(data.stock_floor_image_path, "Stock Floor Image")}>
                            <img src={Eye} alt="stock_floor_image" />
                          </button>
                        ) : "-"}</td>
                    <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.stamped_invoice_image_path ? (
                          <button onClick={() => handleSetImage(data.stamped_invoice_image_path, "Stamped Invoice Image")}>
                            <img src={Eye} alt="stamped_invoice_image" />
                          </button>
                        ) : "-"}</td>


                  </tr>
                ))}
            </tbody>
          </table>
          {employees?.items?.length === 0 && !loading && (
            <>
              <div className="px-4 py-3 border text-center text-black-600 w-full flex items-center justify-center">
                {t("planogram.noresultsfound")}
              </div>
            </>
          )}
          
        </div>
        <div className="sm:hidden bg-white p-2 border-t-2 mt-auto">
          <PaginationComponent
            totalCount={employees?.total}
            itemsPerPage={employees?.size}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
        {viewImg && (
            <>
                <ImageDailog
                    imageUrl={imgUrl}
                    onClose={() => setViewImg(false)}
                    title={imgType}
                />
                {imageLoading && (
                    <div style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999}}>
                        <Loader />
                    </div>
                )}
            </>
        )}
      </div>
    </DashboardPage>
  );
};

export default DeliveryImagesReport;
